var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 19.748V19.748C4.5585 16.287 7.97226 13.6045 12.0108 13.748H15.9892C20.0277 13.6045 23.4415 16.287 23.625 19.748V19.748",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.74799V19.748",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.74799C15.933 7.74799 17.5 6.40484 17.5 4.74799C17.5 3.09113 15.933 1.74799 14 1.74799C12.067 1.74799 10.5 3.09113 10.5 4.74799C10.5 6.40484 12.067 7.74799 14 7.74799Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 24.248C5.82475 24.248 7 23.2406 7 21.998C7 20.7553 5.82475 19.748 4.375 19.748C2.92525 19.748 1.75 20.7553 1.75 21.998C1.75 23.2406 2.92525 24.248 4.375 24.248Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 24.248C15.4497 24.248 16.625 23.2406 16.625 21.998C16.625 20.7553 15.4497 19.748 14 19.748C12.5503 19.748 11.375 20.7553 11.375 21.998C11.375 23.2406 12.5503 24.248 14 24.248Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.625 24.248C25.0747 24.248 26.25 23.2406 26.25 21.998C26.25 20.7553 25.0747 19.748 23.625 19.748C22.1753 19.748 21 20.7553 21 21.998C21 23.2406 22.1753 24.248 23.625 24.248Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationSwitch);
export default __webpack_public_path__ + "static/media/organization-switch.5b31e8e6.svg";
export { ForwardRef as ReactComponent };